import { CompanyUuidEnum } from '../../company';

export const excludeCompaniesFooterSberInfo = [
  CompanyUuidEnum.novicombank,
  CompanyUuidEnum.alfaBankSpecCourses,
  CompanyUuidEnum.jti,
];

export const isNotContainsExcludedCompanies = (companyId?: string) => {
  if (companyId) {
    return !excludeCompaniesFooterSberInfo.includes(
      companyId as CompanyUuidEnum
    );
  }

  return true;
};
